import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';
import { ForgotPasswordComponent } from './forgot-password.component';
import { ForgotPasswordRoutingModule } from './forgot-password-routing.module';
import { FormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { AppMaterialModule } from '../../shared/appMaterial/app-material.module';

@NgModule({
  imports: [
    CommonModule,
    ForgotPasswordRoutingModule,
    SharedModule,
    FlexLayoutModule.withConfig({ useColumnBasisZero: false })
  ],
  declarations: [ForgotPasswordComponent],
  exports: [ForgotPasswordComponent],
  providers: []
})
export class ForgotPasswordModule {}
